module.exports = __webpack_public_path__ + "media/images/icons/interaction-4f6d9dbc62d58b321f7ac59f6356066b.png";